import React, { useState, useEffect } from 'react';
import Tabs from '@material-ui/core/Tabs';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import BritiveQueryData from '../BritiveQueryData/BritiveQueryData';
import MyQueries from '../MyQueries/MyQueries';
import { useSelector, useDispatch } from 'react-redux';
import { getResponseAPIData } from '../../services/apiService';
import consts from '../../utils/consts';
import { LeftTabNav, RightTabNav, StyledTab, StyledMyTab, StyledSpinner, StyledWrapper } from './QueriesManagerStyle';
import { pushQueriesLoader, pushTotalMyQureies, pushTotalBritiveQureies } from '../../slices/QueriesManagerSlice';
import { IsdownloadCSV, pushIsSaveAsPopUp, showSnackEnable, pushgetApiResponse, showTostLoader } from '../../slices/customQueryHeaderSlice';
const {
  queries,
  baseUrlquery
} = consts;
const useStyles = makeStyles({
  customLabelColor: {
    color: 'yellow',
    width: '101px'
  }
});

const QueriesManager = () => {
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [continuePagination, setContinuePagination] = useState(false);
  const [tableData, setTableData] = useState([]);

  const handleChange = (event, activeIndex) => {
    setActiveIndex(activeIndex);

    if (activeIndex === 0) {
      setPageNumber(activeIndex);
      setContinuePagination(true);
      setTableData([]);
      dispatch(showSnackEnable(true));
      dispatch(showTostLoader(true));
      dispatch(pushgetApiResponse({
        data: null,
        type: 'getQuery'
      }));
    }
  };

  const setQueriesLoader = useSelector(state => state.queriesManager.setQueriesLoader);
  const totalMyQureies = useSelector(state => state.queriesManager.totalMyQureies);
  const totalBritiveQureies = useSelector(state => state.queriesManager.totalBritiveQureies);
  const saveQueryResponseData = useSelector(state => state.customQueryHeader.getQuery);
  const britQueryResponseData = useSelector(state => state.customQueryHeader.getBritQuery);
  const classes = useStyles();

  const getMyQueries = isDeleted => {
    let paginationStringOrigin = '?limit=10&offset=1';
    let appurl = queries.map(urlEntityName => baseUrlquery + urlEntityName + paginationStringOrigin);
    let url = '/api/ada/queryengine/britivequeries' + paginationStringOrigin;

    if (isDeleted) {
      dispatch(getResponseAPIData(appurl, 'getQuery'));
    } else {
      dispatch(getResponseAPIData(appurl, 'getQuery'));
      dispatch(getResponseAPIData([url], 'getBritQuery'));
    }
  };

  useEffect(() => {
    getMyQueries(false);
    dispatch(pushQueriesLoader(false));
    dispatch(showSnackEnable(false));
    dispatch(pushIsSaveAsPopUp(false));
  }, [dispatch]);
  useEffect(() => {
    dispatch(pushIsSaveAsPopUp(false));

    if (saveQueryResponseData && saveQueryResponseData[0]?.data?.length > 0) {
      dispatch(pushTotalMyQureies(saveQueryResponseData[0].headers.totalcount));
      dispatch(IsdownloadCSV(false));
    }
  }, [saveQueryResponseData]);
  useEffect(() => {
    if (britQueryResponseData && britQueryResponseData[0]?.data?.length > 0) {
      dispatch(pushTotalBritiveQureies(britQueryResponseData[0].headers.totalcount));
    }
  }, [britQueryResponseData]);
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(LeftTabNav, null, /*#__PURE__*/React.createElement(VerticalTabs, {
    value: activeIndex,
    onChange: handleChange
  }, /*#__PURE__*/React.createElement(StyledTab, {
    label: 'Britive Queries' + '(' + totalBritiveQureies + ')',
    classes: {
      textColorSecondary: classes.customLabelColor
    }
  }), /*#__PURE__*/React.createElement(StyledMyTab, {
    label: 'My Queries' + '(' + totalMyQureies + ')',
    classes: {
      textColorSecondary: classes.customLabelColor
    }
  }))), /*#__PURE__*/React.createElement(RightTabNav, null, setQueriesLoader && /*#__PURE__*/React.createElement(StyledSpinner, {
    animation: "border",
    role: "status"
  }), activeIndex === 0 && !setQueriesLoader && /*#__PURE__*/React.createElement(BritiveQueryData, null), activeIndex === 1 && !setQueriesLoader && /*#__PURE__*/React.createElement(MyQueries, {
    resData: saveQueryResponseData,
    retrieveMyQueries: getMyQueries,
    pageNumber: pageNumber,
    setPageNumber: setPageNumber,
    continuePagination: continuePagination,
    setContinuePagination: setContinuePagination,
    tableData: tableData,
    setTableData: setTableData
  })));
};

const VerticalTabs = withStyles(() => ({
  flexContainer: {
    display: 'block',
    position: 'relative',
    overflow: 'hidden'
  },
  indicator: {
    display: 'none'
  }
}))(Tabs);
export default QueriesManager;